module.exports = __webpack_public_path__ + "img/mobile_bg.ddddb7fd.jpg";